import Cookies from 'js-cookie';
import crypto from 'crypto';
const uuidv1 = require('uuid/v1');

const global = {
  // 发送到 adobe 的语言转换
  getAdobeLanguage() {
    const lang = localStorage.language || 'en';
    if (lang === 'cn') return 'zh-cn';
    if (lang === 'hk') return 'zh-hant';
    return lang;
  },

  // PageBottom 公共方法 按钮追踪
  trackPageBottom(trackObj) {
    try {
      digitalTracking.event = 'lead_complete'
      digitalTracking = { ...digitalTracking, ...trackObj }
      // _satellite.track('send_transaction_id');
      _satellite.pageBottom();
      console.log('trackPageBottom data:', digitalTracking);
      return true;
    } catch (e) {
      console.error('trackPageBottom error: ' + e);
      return false;
    }
  },

  // PageView 公共方法 页面追踪
  trackPageView(trackObj) {
    try {
      digitalTracking = { ...digitalTracking, ...trackObj }
      _satellite.track('do_trackPageView');
      console.log('trackPageView data:', digitalTracking);
      return true;
    } catch (e) {
      console.error('trackPageView error: ' + e);
      return false;
    }
  },

  // Event 公共方法 事件追踪
  trackEvent(trackObj) {
    try {
      _satellite.track('do_trackEvent', trackObj);
      console.log('trackEvent data:', trackObj);
    } catch (e) {
      console.error('trackEvent error: ' + e);
      return false;
    }
  },

  // 下一步按钮追踪
  trackNextBottonEvent(step) {
    let trackObj = {
      entity: 'uk',
      language: _g.getAdobeLanguage(),
      event_type: 'button',
      event_category: 'open live account',
      event_label: `step ${step}|next`
    }
    _g.trackEvent(trackObj);
  },

  // 步骤页面追踪
  trackStepPage(step) {
    try {
      digitalTracking.entity = 'uk';
      digitalTracking.language = _g.getAdobeLanguage();
      digitalTracking.aanumber = _g.getCookie('aanumber') || ''
      digitalTracking.event_type = 'page';
      digitalTracking.event_category = 'UK open live account';
      digitalTracking.event_label = `step ${step}`;
      digitalTracking.pageName = `UK open live account step ${step}`;
      const isFitstLoad = _g.getCookie('isFitstLoad') || 0
      if (isFitstLoad == 1) {
        _g.setCookie('isFitstLoad', 0)
      } else {
        _satellite.track('do_trackPageView');
      }
      console.log('trackStepPage data:', digitalTracking);
      return true;
    } catch (e) {
      console.error('trackStepPage error: ' + e);
      return false;
    }
  },
  
  setCookie(key, value, option) {
    try {
      // eg: option = { expires: 14, domain: '.yourdomain.com' }
      Cookies.set(key, value, { ...{ expires: 7 }, ...option });
      return true;
    } catch (e) {
      console.error('setCookie error: ' + e);
      return false;
    }
  },

  getCookie(key) {
    return Cookies.get(key);
  },

  removeCookie(key, option) {
    //eg: option = { path: '', domain: '.yourdomain.com' }
    return Cookies.remove(key, { ...{ path: '' }, ...option });
  },

  setCookieForAAnumber(aanumber) {
    _g.setCookie('aanumber', aanumber, { expires: 90, domain: ".atfx.com" });
    _g.setCookie('aanumber', aanumber, { expires: 90, domain: ".atfx-chinese.com" });
    _g.setCookie('aanumber', aanumber, { expires: 90, domain: ".atfx.com.cn" });
    _g.setCookie('aanumber', aanumber, { expires: 90, domain: ".chinese-atfx.com" });
    _g.setCookie('aanumber', aanumber, { expires: 90 });
  },

  setCookieForLeadid(leadid) {
    _g.setCookie('leadid', leadid, { expires: 90, domain: ".atfx.com" });
    _g.setCookie('leadid', leadid, { expires: 90, domain: ".atfx-chinese.com" });
    _g.setCookie('leadid', leadid, { expires: 90, domain: ".atfx.com.cn" });
    _g.setCookie('leadid', leadid, { expires: 90, domain: ".chinese-atfx.com" });
    _g.setCookie('leadid', leadid, { expires: 90 });
  },

  // 生成 aanumber 16 位随机字符串 
  generateAAnumber() {
    return crypto.createHash('md5').update(uuidv1()).digest('hex').substr(8, 16);
  }
}

export default global



// WEBPACK FOOTER //
// ./src/assets/js/global.js